export const handleNumberwithPadding = (num) => {
  if (isNaN(num)) return;
  return num < 10 ? `0${num}` : num;
};

export const handleCurrency = (currency) => {
  if (isNaN(currency) || !currency) return "";
  currency = Number(currency);
  return currency > -1 ? `${currency?.toFixed(2)}` : "";
};
